import React, { useEffect, useState, createElement } from 'react';
import { Check, ChevronDown, ChevronUp, Star, AlertTriangle, ArrowRight, X, Clock, CheckCircle } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { PagePreviewCarousel } from './components/PagePreviewCarousel';
// Images
const IMAGES = {
  main: 'https://cdn.magicpatterns.com/uploads/2VQKnKVA27cEQ3aLU4W52R/Diseno_sin_titulo_(11).png',
  bonus1: 'https://cdn.magicpatterns.com/uploads/f4jmsJwzhJgEyvAxN7Va5u/Bonus_1_canva.png',
  bonus2: 'https://cdn.magicpatterns.com/uploads/k14DdRdwGwVYvCBgvJpSoL/bonus_2_canva.png',
  bonus3: 'https://cdn.magicpatterns.com/uploads/71iDKa4tTcWYqd5LHcCq21/Bonus_3_canva.png'
};
const PURCHASE_LINK = 'https://payments.tiendasinlimites.com/cart/45114660061375:1';
// FAQ Data
const FAQS = [{
  q: '¿Es un producto digital?',
  a: 'Sí. Acceso y descarga inmediata apenas completás el pago.'
}, {
  q: '¿Qué incluye el MEGA PACK?',
  a: '6 tomos + 3 bonus prácticos: workbook, planner y guía de emergencia.'
}, {
  q: '¿Para quién está pensado?',
  a: 'Para mujeres adultas, profesionales y emprendedoras que procrastinan por saturación o perfeccionismo.'
}, {
  q: '¿Sirve si tengo poco tiempo?',
  a: 'Sí. Todo está diseñado en micro-acciones y ejercicios cortos.'
}, {
  q: '¿Es motivacional o práctico?',
  a: 'Es práctico. No es teoría: se aplica desde el primer día, incluso si estás cansada.'
}, {
  q: '¿En cuánto tiempo puedo ver resultados?',
  a: 'El sistema está pensado para generar cambios reales en 4 semanas, a tu ritmo.'
}];
// Testimonials Data
const TESTIMONIALS = [{
  quote: 'No me hizo hacer más. Me ayudó a dejar de pelearme conmigo misma y empezar, incluso en días difíciles.',
  name: 'Mariana López',
  role: 'Consultora independiente, Buenos Aires'
}, {
  quote: 'No es motivación vacía. Es entender por qué me bloqueo y qué hacer cuando pasa, sin culpa.',
  name: 'Luciana Ferreyra',
  role: 'Psicopedagoga, Mendoza'
}, {
  quote: 'Por primera vez no abandoné a la semana. Avancé poco, pero de verdad. Y eso cambió todo.',
  name: 'Carolina Méndez',
  role: 'Profesional freelance, Rosario'
}, {
  quote: 'Sentía que procrastinaba todo el tiempo y me castigaba por eso. Este sistema me ordenó la cabeza y el ritmo.',
  name: 'Florencia Ríos',
  role: 'Emprendedora digital, Córdoba'
}, {
  quote: 'Tengo mil responsabilidades. Este material me devolvió foco sin exigirme ser otra persona.',
  name: 'Verónica Suárez',
  role: 'Emprendedora y madre, La Plata'
}];
export function App() {
  // Meta Pixel Initialization
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1611838376665518');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=1611838376665518&ev=PageView&noscript=1" />`;
    document.body.appendChild(noscript);
  }, []);
  const scrollToPurchase = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-white min-h-screen pb-20" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      {/* 1. URGENCY BAR */}
      <div className="sticky top-0 z-50 bg-red-600 text-white py-1.5 px-4 shadow-sm" data-id="element-2">
        <div className="max-w-5xl mx-auto flex flex-col sm:flex-row justify-between items-center gap-1 text-center text-sm" data-id="element-3">
          <CountdownTimer data-id="element-4" />
          <div className="flex items-center bg-yellow-400 text-red-900 px-2 py-0.5 rounded-full font-bold text-xs" data-id="element-5">
            <span className="mr-1" data-id="element-6">🔥</span> SOLO QUEDAN 3 CUPOS
          </div>
        </div>
      </div>

      {/* 2. HERO SECTION */}
      <section className="pt-4 md:pt-6 pb-8 px-4 bg-gradient-to-b from-gray-50 to-white" data-id="element-7">
        <div className="max-w-4xl mx-auto text-center" data-id="element-8">
          <p className="text-lg md:text-xl text-gray-600 font-medium mb-2 md:mb-3" data-id="element-9">
            🌿 Para mujeres exigentes, con muchas responsabilidades y la mente
            saturada
          </p>

          <h1 className="font-extrabold leading-tight mb-1 text-center" data-id="element-10">
            <span className="block text-4xl md:text-5xl text-amber-600 font-extrabold mb-1" data-id="element-11">
              <span className="relative inline-block" data-id="element-12">
                <span className="absolute right-full top-[0.1em] text-[0.8em] mr-1" data-id="element-13">
                  ≡
                </span>
                MegaPack
              </span>
            </span>
            <span className="block text-5xl md:text-6xl lg:text-7xl text-gray-700" data-id="element-14">
              Acción Total
            </span>
          </h1>

          <div className="mb-1 flex justify-center transform hover:scale-105 transition-transform duration-300 cursor-pointer" onClick={scrollToPurchase} data-id="element-15">
            <img src={IMAGES.main} alt="MegaPack Acción Total" className="block w-full max-w-2xl drop-shadow-2xl rounded-lg mx-auto" data-id="element-16" />
          </div>

          <p className="text-xl md:text-2xl text-gray-800 font-semibold mb-4 md:mb-6 max-w-3xl mx-auto" data-id="element-17">
            Organizá tus objetivos y ahorrá meses de frustración con un sistema
            de acción diaria{' '}
            <span className="bg-yellow-200 px-1" data-id="element-18">listo para usar</span>
          </p>

          <div className="flex flex-col md:flex-row flex-wrap justify-center gap-3 md:gap-4 mb-8 md:mb-10 text-lg text-gray-700 font-medium" data-id="element-19">
            <span className="flex items-center justify-center" data-id="element-20">
              <Check className="text-green-500 mr-2" data-id="element-21" /> Cortás el ruido mental
              que te frena
            </span>
            <span className="flex items-center justify-center" data-id="element-22">
              <Check className="text-green-500 mr-2" data-id="element-23" /> Sabés exactamente qué
              hacer hoy
            </span>
            <span className="flex items-center justify-center" data-id="element-24">
              <Check className="text-green-500 mr-2" data-id="element-25" /> Avanzás sin agotarte…
              pero avanzás
            </span>
          </div>

          <button onClick={scrollToPurchase} className="w-full max-w-md bg-green-600 hover:bg-green-500 text-white text-2xl font-bold py-5 px-8 rounded-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 animate-pulse-slow" data-id="element-26">
            👉 SÍ, QUIERO ACCEDER AHORA
          </button>

          <div className="mt-5 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-27">
            <div className="bg-green-100 rounded-full p-1 mr-2" data-id="element-28">
              <Check className="w-4 h-4 text-green-600" data-id="element-29" />
            </div>
            Garantía de satisfacción de 7 días
          </div>
        </div>
      </section>

      {/* 3. PAIN POINT SECTION */}
      <section className="py-8 px-4 bg-white" data-id="element-30">
        <div className="max-w-3xl mx-auto" data-id="element-31">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8" data-id="element-32">
            Querés avanzar, pero algo siempre te frena.
          </h2>

          <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-red-500 shadow-sm mb-8" data-id="element-33">
            <p className="text-2xl font-semibold text-center text-gray-800 italic" data-id="element-34">
              ¿Te pasa que solo pensar en empezar ya te agota?
            </p>
          </div>

          <div className="space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-35">
            <p data-id="element-36">
              No porque seas perezosa. No porque no te importe. Y
              definitivamente no porque te falte disciplina.
            </p>
            <p className="font-bold text-xl text-gray-900" data-id="element-37">
              👉 Sino porque estás mentalmente saturada.
            </p>
            <p data-id="element-38">
              Tenés demasiadas responsabilidades, expectativas altas y cero
              margen interno. Cada vez que intentás avanzar, algo adentro se
              frena.
            </p>
            <p data-id="element-39">
              Pensás demasiado. Te exigís demasiado. Querés hacerlo perfecto… o
              no hacerlo.
            </p>
            <p data-id="element-40">Y cuando finalmente intentás empezar, ya estás cansada.</p>
            <p className="font-bold text-xl text-gray-900" data-id="element-41">
              👉 Esto no es falta de voluntad. Es falta de sistema.
            </p>
          </div>
        </div>
      </section>

      {/* 4. PROBLEM SECTION */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-42">
        <div className="max-w-3xl mx-auto" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-44">
            El problema que nadie dice en voz alta
          </h2>

          <div className="space-y-4 mb-12" data-id="element-45">
            <p className="text-xl text-gray-300 mb-6" data-id="element-46">
              Si esto te resulta familiar:
            </p>
            {['Postergás cosas importantes', 'Empezás y abandonás', 'Vivís con la cabeza llena', 'Te sentís en deuda con vos misma', 'Lo importante queda siempre para después'].map((item, i) => <div key={i} className="flex items-center bg-gray-800 p-4 rounded-lg" data-id="element-47">
                <div className="bg-red-500/20 p-2 rounded-full mr-4" data-id="element-48">
                  <X className="text-red-500 w-6 h-6" data-id="element-49" />
                </div>
                <span className="text-lg font-medium" data-id="element-50">{item}</span>
              </div>)}
          </div>

          <div className="bg-yellow-500 text-gray-900 p-6 rounded-xl text-center shadow-lg" data-id="element-51">
            <div className="space-y-1" data-id="element-52">
              <p className="text-xl font-bold" data-id="element-53">
                El problema no es que no quieras avanzar.
              </p>
              <p className="text-xl font-bold" data-id="element-54">
                El problema es intentar hacerlo sin un sistema que sostenga tu
                mente y tu energía.
              </p>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-55">
            <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-xl font-bold py-4 px-8 rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200" data-id="element-56">
              🚀 QUIERO EMPEZAR A AVANZAR HOY
            </button>
          </div>
        </div>
      </section>

      {/* 5. SOLUTION SECTION */}
      <section className="pt-6 pb-16 px-4 bg-white" data-id="element-57">
        <div className="max-w-4xl mx-auto text-center" data-id="element-58">
          <span className="inline-block bg-green-500 text-white px-5 py-1.5 rounded-full font-bold text-xl md:text-2xl mb-8" data-id="element-59">
            ✅ LA SOLUCIÓN
          </span>

          <h2 className="font-extrabold text-gray-900 mb-6" data-id="element-60">
            <span className="block text-2xl md:text-3xl text-amber-600 font-bold mb-2" data-id="element-61">
              MegaPack
            </span>
            <span className="block text-5xl md:text-6xl" data-id="element-62">Acción Total</span>
          </h2>

          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto" data-id="element-63">
            Un sistema completo, diseñado para avanzar sin exigirte ni agotarte.
          </p>

          <div className="grid md:grid-cols-3 gap-10 mb-12" data-id="element-64">
            <div className="bg-blue-50 p-6 rounded-xl" data-id="element-65">
              <div className="text-4xl mb-4" data-id="element-66">📂</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-67">Abrís el material</h3>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl" data-id="element-68">
              <div className="text-4xl mb-4" data-id="element-69">⚡</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-70">Bajás la ansiedad</h3>
              <p className="text-sm text-gray-600" data-id="element-71">y el ruido mental</p>
            </div>
            <div className="bg-blue-50 p-6 rounded-xl" data-id="element-72">
              <div className="text-4xl mb-4" data-id="element-73">🚀</div>
              <h3 className="font-bold text-lg mb-2" data-id="element-74">Aplicás micro-acciones</h3>
              <p className="text-sm text-gray-600" data-id="element-75">reales</p>
            </div>
          </div>

          <p className="text-2xl font-bold text-gray-800 mb-8" data-id="element-76">
            Avanzar puede ser más simple de lo que pensás.
          </p>

          <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-xl font-bold py-4 px-10 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-77">
            ACCEDER AL MEGAPACK AHORA
          </button>
        </div>
      </section>

      {/* 6. WHAT'S INCLUDED */}
      <section className="pt-6 pb-16 px-4 bg-gray-50 border-y border-gray-200" data-id="element-78">
        <div className="max-w-4xl mx-auto" data-id="element-79">
          <div className="text-center mb-12" data-id="element-80">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-81">
              📘 ¿Qué incluye el sistema Acción Total?
            </h2>
            <p className="text-xl text-gray-600" data-id="element-82">Sistema completo en 6 Tomos</p>
          </div>

          <div className="grid gap-6" data-id="element-83">
            {[{
            title: 'Tomo 1 – Acción Total',
            desc: 'El error de forzar y el inicio de una acción que sí se sostiene'
          }, {
            title: 'Tomo 2 – La Trampa Emocional',
            desc: 'Un viaje hacia la comprensión profunda de lo que realmente frena tu acción'
          }, {
            title: 'Tomo 3 – Dirección y Foco',
            desc: 'Dirección, sentido y foco. De hacer cosas… a saber por qué y para qué.'
          }, {
            title: 'Tomo 4 – El Sistema de Acción Sostenible',
            desc: 'Cómo dejar de depender de la motivación y avanzar incluso en días difíciles'
          }, {
            title: 'Tomo 5 – Productividad Humana y Sostenible',
            desc: 'Cómo avanzar sin agotarte ni volver a postergar'
          }, {
            title: 'Tomo 6 – Integración y Autonomía',
            desc: 'El sistema que te permite avanzar sin agotarte ni volver a postergar'
          }].map((tomo, i) => <div key={i} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 flex flex-col md:flex-row md:items-center gap-4 hover:shadow-md transition-shadow" data-id="element-84">
                <div className="bg-blue-600 text-white font-bold py-2 px-4 rounded md:w-24 text-center flex-shrink-0" data-id="element-85">
                  TOMO {i + 1}
                </div>
                <div data-id="element-86">
                  <h3 className="font-bold text-lg text-gray-900" data-id="element-87">
                    {tomo.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-88">{tomo.desc}</p>
                </div>
              </div>)}
          </div>

          <p className="text-center text-lg font-medium text-gray-700 mt-10 italic" data-id="element-89">
            Un sistema completo para que avances todos los días, con foco y
            dirección, sin exigirte ni agotarte.
          </p>
        </div>
      </section>

      {/* 7. BEFORE VS AFTER */}
      <section className="py-16 px-4 bg-white" data-id="element-90">
        <div className="max-w-5xl mx-auto" data-id="element-91">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-92">
            🔄 Antes vs Después
          </h2>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-93">
            {/* Before */}
            <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-94">
              <h3 className="text-2xl font-bold text-red-800 mb-6 text-center border-b border-red-200 pb-4" data-id="element-95">
                Antes del MegaPack
              </h3>
              <ul className="space-y-4" data-id="element-96">
                {['Bloqueo constante', 'Ruido mental permanente', 'Empezar con fuerza y abandonar', 'Culpa por no avanzar', 'Cansancio emocional'].map((item, i) => <li key={i} className="flex items-center text-red-900" data-id="element-97">
                    <X className="w-5 h-5 text-red-500 mr-3 flex-shrink-0" data-id="element-98" />
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg transform md:-translate-y-4" data-id="element-99">
              <h3 className="text-2xl font-bold text-green-800 mb-6 text-center border-b border-green-200 pb-4" data-id="element-100">
                Después del MegaPack
              </h3>
              <ul className="space-y-4" data-id="element-101">
                {['Claridad inmediata', 'Pasos chicos pero ejecutables', 'Foco diario', 'Constancia sin autoexigencia extrema', 'Acción sostenida, incluso en días difíciles'].map((item, i) => <li key={i} className="flex items-center text-green-900 font-medium" data-id="element-102">
                    <Check className="w-5 h-5 text-green-600 mr-3 flex-shrink-0" data-id="element-103" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. BONUSES */}
      <section className="py-16 px-4 bg-gray-900 text-white" data-id="element-104">
        <div className="max-w-5xl mx-auto" data-id="element-105">
          <div className="text-center mb-12" data-id="element-106">
            <h2 className="text-3xl md:text-5xl font-bold text-yellow-400 mb-4" data-id="element-107">
              🎁 Regalos especiales
            </h2>
            <p className="text-xl text-white" data-id="element-108">
              BONOS INCLUIDOS HOY (sin costo adicional)
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-109">
            {[{
            title: 'Bono #1 – Workbook de Activación',
            desc: 'Ejercicios diarios listos para aplicar desde el primer día.',
            price: '$29.990',
            img: IMAGES.bonus1
          }, {
            title: 'Bono #2 – Planner Anti-Procrastinación',
            desc: 'Organizá tu semana con foco, sin depender de la motivación.',
            price: '$24.990',
            img: IMAGES.bonus2
          }, {
            title: 'Bono #3 – Guía de Emergencia',
            desc: 'Qué hacer cuando te bloqueás y no podés arrancar.',
            price: '$19.990',
            img: IMAGES.bonus3
          }].map((bonus, i) => <div key={i} className="bg-gray-800 rounded-xl overflow-hidden shadow-xl hover:shadow-2xl transition-all cursor-pointer group" onClick={scrollToPurchase} data-id="element-110">
                <div className="aspect-square bg-white p-4 flex items-center justify-center" data-id="element-111">
                  <img src={bonus.img} alt={bonus.title} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300" data-id="element-112" />
                </div>
                <div className="p-4 text-center" data-id="element-113">
                  <h3 className="font-bold text-lg mb-1 text-white" data-id="element-114">
                    {bonus.title}
                  </h3>
                  <p className="text-sm text-gray-400 mb-2" data-id="element-115">{bonus.desc}</p>
                  <div className="flex justify-center items-center gap-2" data-id="element-116">
                    <span className="text-gray-400 line-through text-sm" data-id="element-117">
                      Valor: {bonus.price}
                    </span>
                    <span className="text-green-400 font-bold" data-id="element-118">HOY: $0</span>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 9. PRICING SECTION */}
      <section id="compra" className="pt-8 pb-16 px-4 bg-yellow-50 scroll-mt-14" data-id="element-119">
        <div className="max-w-3xl mx-auto" data-id="element-120">
          <div className="text-center mb-8" data-id="element-121">
            <p className="text-4xl md:text-5xl font-bold text-red-600" data-id="element-122">
              Acceso inmediato
            </p>
            <p className="text-4xl md:text-5xl font-bold text-red-600" data-id="element-123">
              <span className="relative inline-block" data-id="element-124">
                <span className="absolute -left-11 md:-left-14 top-0" data-id="element-125">🔥</span>
                Oferta por
              </span>
            </p>
            <p className="text-4xl md:text-5xl font-bold text-red-600" data-id="element-126">
              tiempo limitado
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-yellow-400" data-id="element-127">
            <div className="p-8 md:p-12" data-id="element-128">
              <h3 className="text-2xl font-bold text-center mb-8" data-id="element-129">
                🎁 Qué incluye esta oferta hoy
              </h3>

              <div className="grid md:grid-cols-2 gap-4 mb-8" data-id="element-130">
                {['6 Tomos completos (sistema paso a paso)', 'Workbook de Activación diaria', 'Planner Anti-Procrastinación listo para usar', 'Guía de Emergencia para días difíciles', 'Acceso digital inmediato', 'Un solo pago (sin suscripciones)', 'Descarga digital', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center" data-id="element-131">
                    <CheckCircle className="text-green-500 w-5 h-5 mr-2 flex-shrink-0" data-id="element-132" />
                    <span className="text-gray-700 font-medium" data-id="element-133">{item}</span>
                  </div>)}
              </div>

              <div className="text-center border-t border-b border-gray-100 py-8 mb-8" data-id="element-134">
                <p className="text-gray-500 text-lg mb-2" data-id="element-135">
                  Precio regular:{' '}
                  <span className="line-through" data-id="element-136">ARS $49.990</span>
                </p>
                <p className="text-5xl md:text-6xl font-extrabold text-green-600 mb-2" data-id="element-137">
                  <span className="text-2xl text-red-500 font-bold align-top mr-2" data-id="element-138">
                    🔥 HOY SOLO:
                  </span>
                  $19.990
                </p>
                <p className="text-sm text-gray-400" data-id="element-139">ARS (Pesos Argentinos)</p>
              </div>

              <a href={PURCHASE_LINK} className="block w-full bg-green-600 hover:bg-green-500 text-white text-center text-2xl md:text-3xl font-bold py-6 px-4 rounded-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 animate-pulse-slow mb-4" data-id="element-140">
                👉 OBTENER MI MEGAPACK HOY
              </a>

              <div className="flex justify-center gap-4 opacity-60 grayscale" data-id="element-141">
                <img src="https://cdn-icons-png.flaticon.com/512/196/196578.png" alt="Visa" className="h-8" data-id="element-142" />
                <img src="https://cdn-icons-png.flaticon.com/512/196/196566.png" alt="Mastercard" className="h-8" data-id="element-143" />
                <img src="https://cdn-icons-png.flaticon.com/512/196/196565.png" alt="PayPal" className="h-8" data-id="element-144" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 10. GUARANTEE */}
      <section className="pt-2 pb-4 px-4 bg-gray-50 border-y border-gray-200" data-id="element-145">
        <div className="max-w-2xl mx-auto text-center" data-id="element-146">
          {/* Professional Seal */}
          <div className="inline-flex flex-col items-center justify-center mb-0" data-id="element-147">
            <img src="https://cdn.magicpatterns.com/uploads/qT2aazwLchatL42eBRATb5/Diseno_sin_titulo_(5).png" alt="Garantía 7 Días" className="w-72 h-72 object-contain" data-id="element-148" />
          </div>

          {/* Title */}
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 -mt-4" data-id="element-149">
            Probalo sin riesgo durante 7 días
          </h3>

          {/* Guarantee text */}
          <div className="bg-white border border-gray-200 rounded-lg p-6 mb-8 max-w-xl mx-auto" data-id="element-150">
            <p className="text-gray-800 text-lg leading-relaxed" data-id="element-151">
              Si en los primeros 7 días sentís que no es para vos, nos escribís
              y te devolvemos el{' '}
              <span className="font-semibold" data-id="element-152">100% de tu dinero</span>.
            </p>
            <p className="text-gray-800 text-lg font-semibold mt-2" data-id="element-153">
              Sin vueltas. Sin preguntas.
            </p>
          </div>

          {/* Trust badges */}
          <div className="flex flex-col sm:flex-row justify-center gap-6 text-gray-700" data-id="element-154">
            <div className="flex items-center justify-center gap-2" data-id="element-155">
              <CheckCircle className="w-5 h-5 text-gray-800" data-id="element-156" />
              <span className="text-sm font-medium" data-id="element-157">Devolución 100%</span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-158">
              <CheckCircle className="w-5 h-5 text-gray-800" data-id="element-159" />
              <span className="text-sm font-medium" data-id="element-160">
                Acceso digital inmediato
              </span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-161">
              <CheckCircle className="w-5 h-5 text-gray-800" data-id="element-162" />
              <span className="text-sm font-medium" data-id="element-163">Soporte humano</span>
            </div>
          </div>
        </div>
      </section>

      {/* 11. TESTIMONIALS */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-164">
        <div className="max-w-5xl mx-auto" data-id="element-165">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-166">
            💬 Lo que dicen otras mujeres que ya lo usaron
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-167">
            {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-168">
                <div className="flex text-yellow-400 mb-4" data-id="element-169">
                  {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-170" />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-171">"{t.quote}"</p>
                <div className="border-t border-gray-100 pt-4" data-id="element-172">
                  <p className="font-bold text-gray-900" data-id="element-173">{t.name}</p>
                  <p className="text-sm text-gray-500" data-id="element-174">{t.role}</p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 11.5 PAGE PREVIEW CAROUSEL */}
      <PagePreviewCarousel data-id="element-175" />

      {/* 12. FAQ */}
      <section className="py-16 px-4 bg-white" data-id="element-176">
        <div className="max-w-3xl mx-auto" data-id="element-177">
          <h2 className="text-3xl font-bold text-center mb-12" data-id="element-178">
            ❓ Preguntas frecuentes antes de acceder
          </h2>

          <div className="space-y-4" data-id="element-179">
            {FAQS.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-180" />)}
          </div>
        </div>
      </section>

      {/* 13. FINAL CTA */}
      <section className="py-20 px-4 bg-gray-900 text-white text-center" data-id="element-181">
        <div className="max-w-4xl mx-auto" data-id="element-182">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-183">
            Avanzar puede ser más simple de lo que pensás
          </h2>
          <p className="text-xl text-gray-300 mb-10" data-id="element-184">
            No necesitás exigirte más. Necesitás un sistema que te sostenga
            todos los días.
          </p>
          <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-500 text-white text-2xl font-bold py-5 px-10 rounded-full shadow-xl hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200" data-id="element-185">
            👉 Empezar ahora con Acción Total
          </button>
        </div>
      </section>

      {/* 14. FOOTER */}
      <footer className="bg-black text-gray-500 py-8 px-4 text-center text-sm" data-id="element-186">
        <div className="max-w-4xl mx-auto" data-id="element-187">
          <p className="mb-2" data-id="element-188">© 2026 MegaPack Acción Total</p>
          <div className="flex justify-center gap-4" data-id="element-189">
            <span data-id="element-190">Privacidad</span>
            <span data-id="element-191">·</span>
            <span data-id="element-192">Términos y Condiciones</span>
          </div>
        </div>
      </footer>
    </div>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-193">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex justify-between items-center p-5 bg-gray-50 hover:bg-gray-100 text-left transition-colors" data-id="element-194">
        <span className="font-bold text-gray-900" data-id="element-195">{question}</span>
        {isOpen ? <ChevronUp className="text-gray-500" data-id="element-196" /> : <ChevronDown className="text-gray-500" data-id="element-197" />}
      </button>
      {isOpen && <div className="p-5 bg-white text-gray-700 border-t border-gray-200 animate-fade-in" data-id="element-198">
          {answer}
        </div>}
    </div>;
}